var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrDwn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 117,
    viewBox: "0 0 18 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 8C1.0001 12.4183 4.58182 16 9.0001 16C13.4184 16 17.0001 12.4183 17.0001 8C17.0001 3.58172 13.4184 0 9.0001 0C4.58182 0 1.0001 3.58172 1.0001 8ZM9.0001 116.5L17.6604 101.5H0.339844L9.0001 116.5ZM7.5001 8V9.9375H10.5001V8H7.5001ZM7.5001 13.8125V17.6875H10.5001V13.8125H7.5001ZM7.5001 21.5625V25.4375H10.5001V21.5625H7.5001ZM7.5001 29.3125V33.1875H10.5001V29.3125H7.5001ZM7.5001 37.0625V40.9375H10.5001V37.0625H7.5001ZM7.5001 44.8125V48.6875H10.5001V44.8125H7.5001ZM7.5001 52.5625V56.4375H10.5001V52.5625H7.5001ZM7.5001 60.3125V64.1875H10.5001V60.3125H7.5001ZM7.5001 68.0625V71.9375H10.5001V68.0625H7.5001ZM7.5001 75.8125V79.6875H10.5001V75.8125H7.5001ZM7.5001 83.5625V87.4375H10.5001V83.5625H7.5001ZM7.5001 91.3125V95.1875H10.5001V91.3125H7.5001ZM7.5001 99.0625V102.938H10.5001V99.0625H7.5001ZM7.5001 106.812V110.688H10.5001V106.812H7.5001Z",
    fill: "#E08773"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_1051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrDwn2);
export default __webpack_public_path__ + "static/media/arr_dwn_2.d138d0b0cbe5508346f83664bade00dd.svg";
export { ForwardRef as ReactComponent };